import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Nguyen Gia Bao💡💡💡`}</h1>
    <p><strong parentName="p">{`IT-HelpDesk`}</strong>{`🥳 | `}<strong parentName="p">{`Web-Developer`}</strong>{`🧐.`}</p>
    <p><inlineCode parentName="p">{`I'm creating novice web experiences as an Intern to Full-time as a semi-developer for the next generation of consumer-facing companies.`}</inlineCode></p>
    <a href='https://app.daily.dev/baobaoack000'>
  <img src='https://api.daily.dev/devcards/195c0f24a944495e87036d5d465da255.png?r=rhq' width='300' alt="Nguyen Gia Bao's Dev Card" />
    </a>
    <div className='loader-wrapper' id='load' style={{
      "display": "none"
    }}>
  <span className='loader' style={{
        "width": "100%",
        "height": "100%",
        "position": "absolute",
        "top": "0",
        "left": "0",
        "background": "white",
        "display": "flex",
        "justifyContent": "center",
        "alight": "center"
      }}>
    <img src='Bean-Eater.svg' className='loader-inner' alt='Loader' width='160' />
  </span>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      